module.exports = __webpack_public_path__ + "static/media/chess-bishop.46de9970.svg";